import Vue from 'vue'
import VueRouter from 'vue-router'
import Meta from 'vue-meta'
import Home from '../views/Home-new.vue'
import List from '../views/List.vue'
import Details from '../views/Details.vue'
import About from '../views/About.vue'
import Contact from '../views/Contact.vue'
import MentionsLegales from '../views/MentionsLegales.vue'

Vue.use(VueRouter)
Vue.use(Meta);

export default new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/:search-list.html',
      name: 'ListSearch',
      component: List
    },
    {
      path: '/liste.html',
      name: 'List',
      component: List
    },
    {
      path: '/liste/:title-:id.html',
      name: 'Details',
      component: Details
    },
    {
      path: '/a-propos.html',
      name: 'About',
      component: About
    },
    {
      path: '/contact.html',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/mentions-legales.html',
      name: 'mentions-legales',
      component: MentionsLegales
    }
  ],
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
});
